import React from "react";
import styled from "styled-components";

const PageBodyStyle = styled.div`
    top: 60px;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    overflow: hidden;
    position: absolute;
`;

export const PageBody = ({ children }) =>
    <PageBodyStyle>
        {children}
    </PageBodyStyle>;